import { styled } from '@mui/system';
import Button from '@mui/material/Button';

export const PerspectiveButton = styled(Button)({
  flex: '1 1 auto',
  minWidth: 0,
  maxWidth: 60,
  textAlign: 'center',
  backgroundColor: '#1e1e1e',
  '&:hover': {
    backgroundColor: '#333333',  // ホバー時の背景色
  },
  '&:active': {
    backgroundColor: '#000000',  // アクティブ時の背景色
  },
  '&.Mui-disabled': {
    backgroundColor: '#4a4a4a',  // 無効状態の背景色
  }
});
